import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import JBImage from 'components/essentials/JBImage';
import Placeholder from 'components/consumer/Placeholder';
import useFixedWidthContainerSizeProps from 'hooks/useFixedWidthContainerSizeProps';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import DesktopOnly from 'components/consumer/DesktopOnly';
import PDPInfoTable from '../PDPInfoTable';
import PDPDimensionShotViewer from '../PDPDimensionShotViewer';
const PDPDimensionsContentUI = t0 => {
  const $ = _c(33);
  const {
    dimensionsDesktopImage,
    dimensionsMobileImage,
    dimensions: t1,
    boxDimensions: t2,
    loading: t3,
    onImageClick,
    isSidebarContent: t4,
    hasCylindoDimensionShots: t5,
    dimensionShotUrls: t6,
    currentDimensionShot,
    selectedDimensionShotIndex: t7,
    setSelectedDimensionShotIndex
  } = t0;
  let t8;
  if ($[0] !== t1) {
    t8 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const dimensions = t8;
  let t9;
  if ($[2] !== t2) {
    t9 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  const boxDimensions = t9;
  const loading = t3 === undefined ? false : t3;
  const isSidebarContent = t4 === undefined ? false : t4;
  const hasCylindoDimensionShots = t5 === undefined ? false : t5;
  let t10;
  if ($[4] !== t6) {
    t10 = t6 === undefined ? [] : t6;
    $[4] = t6;
    $[5] = t10;
  } else {
    t10 = $[5];
  }
  const dimensionShotUrls = t10;
  const selectedDimensionShotIndex = t7 === undefined ? 0 : t7;
  const desktopImageFullWidthProps = useFixedWidthContainerSizeProps();
  let t11;
  if ($[6] !== desktopImageFullWidthProps || $[7] !== isSidebarContent) {
    t11 = isSidebarContent ? {
      sizes: "30vw"
    } : desktopImageFullWidthProps;
    $[6] = desktopImageFullWidthProps;
    $[7] = isSidebarContent;
    $[8] = t11;
  } else {
    t11 = $[8];
  }
  const desktopImageProps = t11;
  let t12;
  if ($[9] !== loading) {
    t12 = loading && <Placeholder loading={true} type="rect" style={{
      marginRight: 0,
      marginTop: "10px",
      height: "207px"
    }} />;
    $[9] = loading;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  let t13;
  if ($[11] !== currentDimensionShot || $[12] !== desktopImageProps || $[13] !== dimensionShotUrls || $[14] !== dimensionsDesktopImage || $[15] !== dimensionsMobileImage || $[16] !== hasCylindoDimensionShots || $[17] !== loading || $[18] !== onImageClick || $[19] !== selectedDimensionShotIndex || $[20] !== setSelectedDimensionShotIndex) {
    t13 = !loading && <><MobileAndTabletOnly>{hasCylindoDimensionShots && currentDimensionShot ? <PDPDimensionShotViewer dimensionShots={dimensionShotUrls} selectedDimensionShotIndex={selectedDimensionShotIndex} onIndexChange={setSelectedDimensionShotIndex} className="w-full mt-6 mx-0 mb-4 lg:m-0 lg:hidden aspect-[1/1]" sizes="100vw" height="900" width="900" /> : dimensionsMobileImage && <JBImage src={dimensionsMobileImage} sizes="100vw" height="900" width="900" className="w-full mt-6 mx-0 mb-4 lg:m-0 lg:hidden" />}</MobileAndTabletOnly><DesktopOnly>{hasCylindoDimensionShots && currentDimensionShot ? <PDPDimensionShotViewer dimensionShots={dimensionShotUrls} selectedDimensionShotIndex={selectedDimensionShotIndex} onIndexChange={setSelectedDimensionShotIndex} className={classNames("w-full mt-6 mx-0 mb-4 lg:m-0 max-[1023px]:hidden aspect-[4/3]", {
          "hover:cursor-target": onImageClick
        })} onClick={onImageClick} {...desktopImageProps} /> : dimensionsDesktopImage && <JBImage src={dimensionsDesktopImage} onClick={onImageClick} {...desktopImageProps} className={classNames("w-full mt-6 mx-0 mb-4 lg:m-0 max-[1023px]:hidden", {
          "hover:cursor-target": onImageClick
        })} />}</DesktopOnly></>;
    $[11] = currentDimensionShot;
    $[12] = desktopImageProps;
    $[13] = dimensionShotUrls;
    $[14] = dimensionsDesktopImage;
    $[15] = dimensionsMobileImage;
    $[16] = hasCylindoDimensionShots;
    $[17] = loading;
    $[18] = onImageClick;
    $[19] = selectedDimensionShotIndex;
    $[20] = setSelectedDimensionShotIndex;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== dimensions || $[23] !== loading) {
    t14 = <div className="max-w-[480px] mx-auto my-0"><PDPInfoTable items={dimensions} loading={loading} /></div>;
    $[22] = dimensions;
    $[23] = loading;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== boxDimensions || $[26] !== loading) {
    t15 = boxDimensions?.length > 0 && <div className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14 [content-visibility:auto] [contain-intrinsic-size:0]"><div className="max-w-[480px] mx-auto my-0"><h2 className="text-xl font-bold text-gray">{loading ? <Placeholder type="rect" loading={true} style={{
            height: "28px",
            width: "220px"
          }} /> : "Shipping Dimensions"}</h2></div><div className="max-w-[480px] mx-auto my-0"><PDPInfoTable items={boxDimensions} loading={loading} /></div></div>;
    $[25] = boxDimensions;
    $[26] = loading;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t12 || $[29] !== t13 || $[30] !== t14 || $[31] !== t15) {
    t16 = <div className="PDPDimensionsContentUI">{t12}{t13}{t14}{t15}</div>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  return t16;
};
PDPDimensionsContentUI.propTypes = {
  dimensions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  boxDimensions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  dimensionsDesktopImage: PropTypes.string,
  dimensionsMobileImage: PropTypes.string,
  loading: PropTypes.bool,
  isSidebarContent: PropTypes.bool,
  onImageClick: PropTypes.func,
  hasCylindoDimensionShots: PropTypes.bool,
  dimensionShotUrls: PropTypes.arrayOf(PropTypes.object),
  currentDimensionShot: PropTypes.shape({
    src: PropTypes.string.isRequired,
    dimensionCode: PropTypes.string.isRequired
  }),
  selectedDimensionShotIndex: PropTypes.number,
  setSelectedDimensionShotIndex: PropTypes.func
};
export default PDPDimensionsContentUI;